import { reverse } from "lodash"
import { title } from '../../../corpEnvironment.ts'

const executoryModule = {
    namespaced: true,
    state: {
        stat: null,
        infoList: [],
        isLoading: false,
        isModal: false,
        currentExec: null,
        paginationObj: null
    },
    actions: {
        getStat({ dispatch, commit, rootState }) {

            return dispatch('v3/API', {
                method: 'fssp',
                data: {
                    action: 'stat',
                    ogrn: parseInt(rootState.card?.company?.ogrn)
                }
            }, { root: true }).then(e => {
                if(e.status === 200 && e.data?.code === 0) {
                    commit('setStateObject', { name: 'card.executory.stat', value: e.data?.data }, { root: true })
                }
            }).catch(err => { console.error(err.message) })

        },
        getInfo({ dispatch, commit, rootState }, { year, status, offset = 0, limit = 100 }) {
            commit('setStateObject', { name: 'card.executory.isLoading', value: true }, { root: true })
            commit('setStateObject', { name: 'card.executory.isModal', value: true }, { root: true })
            commit('setStateObject', { name: 'card.executory.currentExec', value: { year, status } }, { root: true })

            return dispatch('v3/API', {
                method: 'fssp',
                data: {
                    action: 'info',
                    ogrn: parseInt(rootState.card?.company?.ogrn),
                    year,
                    status,
                    offset,
                    limit
                }
            }, { root: true }).then(e => {

                if(e.status === 200 && e.data?.code === 0 && e.data?.data?.list?.length ) {
                    commit('setStateObject', { name: 'card.executory.infoList', value: e.data.data.list }, { root: true })
                    commit('setStateObject', { name: 'card.executory.paginationObj', value: e.data.data.pagination }, { root: true })
                } else if(e.status !== 200 && e.data?.code !== 0) {
                    commit('setStateObject', { name: 'card.executory.isModal', value: false }, { root: true })
                    dispatch(
                        'showErrorPopUp', 
                        `При загрузке данных произошла ошибка. Повторите ваш запрос позднее или обратитесь в службу технической поддержки ${title}.`,
                        { root: true }
                    )
                }
                commit('setStateObject', { name: 'card.executory.isLoading', value: false }, { root: true })

            }).catch(err => {

                console.error(err.message)
                commit('setStateObject', { name: 'card.executory.isModal', value: false }, { root: true })
                commit('setStateObject', { name: 'card.executory.isLoading', value: false }, { root: true })
                dispatch(
                    'showErrorPopUp', 
                    `При загрузке данных произошла ошибка. Повторите ваш запрос позднее или обратитесь в службу технической поддержки ${title}.`,
                    { root: true }
                )

            })
        },
        closeModal({ commit }) {
            commit('setStateObject', { name: 'card.executory.isModal', value: false }, { root: true })
            commit('setStateObject', { name: 'card.executory.infoList', value: [] }, { root: true })
            commit('setStateObject', { name: 'card.executory.currentExec', value: null }, { root: true })
            commit('setStateObject', { name: 'card.executory.paginationObj', value: null }, { root: true })
        }
    },
    getters: {
        years(state) {
            if(state.stat) {
                return Object.keys(state.stat).filter(e => !isNaN(parseInt(e)))
            } else {
                return []
            }
        }
    }
}

export default executoryModule